import { render } from "./Stardle.vue?vue&type=template&id=21886be5&scoped=true"
import script from "./Stardle.vue?vue&type=script&lang=js"
export * from "./Stardle.vue?vue&type=script&lang=js"

import "./Stardle.vue?vue&type=style&index=0&id=21886be5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21886be5"]])

export default __exports__